<template>
    <div class="img_filters">
        <div class="tooltipElement">
            <div
                @click="filtersVisible = !filtersVisible"
                class="img_filters-trigger"
                :class="filtersVisible ? 'tooltipHide' : ''"
            >
                {{ $t('editorSceneElementOptionsAdjustImage') }}
            </div>
            <div
                v-show="filtersVisible"
                class="img_filters-container"
            >
                <filterRange
                    v-for="(filter, index) in filters"
                    :key="index"
                    :filter="filter"
                />
            </div>
            <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsAdjustImage') }`" />
        </div>
    </div>
</template>

<script>
    import filterRange from './imageFilterRange.vue';
    import Tooltip from '@/components/Global/Tooltip.vue';

    export default {
        data() {
            return {
                filtersVisible: false,
                filters: {
                    blur: {
                        name: 'blur',
                        title: 'Blur',
                        min: 0,
                        max: 100,
                        enhed: 'px'
                    },
                    brightness: {
                        name: 'brightness',
                        title: 'Brightness',
                        min: 0,
                        max: 200,
                        enhed: '%'
                    },
                    contrast: {
                        name: 'contrast',
                        title: 'Contrast',
                        min: 0,
                        max: 200,
                        enhed: '%'
                    },
                    grayscale: {
                        name: 'grayscale',
                        title: 'Grayscale',
                        min: 0,
                        max: 100,
                        enhed: '%'
                    },
                    sepia: {
                        name: 'sepia',
                        title: 'Sepia',
                        min: 0,
                        max: 100,
                        enhed: '%'
                    }
                }
            }
        },
        components: {
            filterRange,
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    .img_filters {
        z-index: 400;
        width: 120px;
        position: relative;
        font-size: 12px;
        margin: 0 10px 0 0;
    }
    .img_filters > div {
        position: absolute;
        width: 100%;
        box-sizing: border-box;
    }
    .img_filters-trigger {
        display: flex;
        align-items: center;
        border-right: 1px solid #D4D4D4;
        padding: 8px 5px;
        cursor: pointer;
    }
    .img_filters-container {
        padding: 15px 6px 6px;
        width: 230px;
        background-color: #f5f5f5;
        box-shadow: 5px 8px 10px 0px #D4D4D4;
    }
</style>